var React = require('react');

function Miner (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Mining Frigate"),React.createElement("path",{"id":"path1191","className":"cls-1","d":"M104,57.56l-10-10H34l-10,10v30h80Z","key":2})]);
}

Miner.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Miner;

Miner.default = Miner;
